const products = [
  {
    id: 1,
    type: 'reunion',
    category: 'cat_reunion',
    titleKey: 'product_reunion_title',
    descriptionKey: 'product_reunion_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-1.png',
    requiresPartner: true,
    details: [
      'detail_reunion_1',
      'detail_reunion_2',
      'detail_reunion_3',
      'detail_reunion_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_1',
        rating: 5,
        comment: 'review_reunion_1'
      },
      {
        id: 2,
        author: 'reviewer_2',
        rating: 4,
        comment: 'review_reunion_2'
      }
    ]
  },
  {
    id: 2,
    type: 'compatibility',
    category: 'cat_compatibility',
    titleKey: 'product_compatibility_title',
    descriptionKey: 'product_compatibility_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-2.png',
    requiresPartner: true, // 이미 true로 설정되어 있음
    details: [
      'detail_compatibility_1',
      'detail_compatibility_2',
      'detail_compatibility_3',
      'detail_compatibility_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_3',
        rating: 5,
        comment: 'review_compatibility_1'
      },
      {
        id: 2,
        author: 'reviewer_4',
        rating: 5,
        comment: 'review_compatibility_2'
      }
    ]
  },
  {
    id: 3,
    type: 'marriage',
    category: 'cat_marriage',
    titleKey: 'product_marriage_title',
    descriptionKey: 'product_marriage_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-3.png',
    requiresPartner: true,
    details: [
      'detail_marriage_1',
      'detail_marriage_2',
      'detail_marriage_3',
      'detail_marriage_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_5',
        rating: 4,
        comment: 'review_marriage_1'
      }
    ]
  },
  {
    id: 4,
    type: 'love',
    category: 'cat_love',
    titleKey: 'product_love_title',
    descriptionKey: 'product_love_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-4.png',
    requiresPartner: true,
    details: [
      'detail_love_1',
      'detail_love_2',
      'detail_love_3',
      'detail_love_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_6',
        rating: 5,
        comment: 'review_love_1'
      }
    ]
  },
  {
    id: 5,
    type: 'newyear',
    category: 'cat_newyear',
    titleKey: 'product_newyear_title',
    descriptionKey: 'product_newyear_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-5.png',
    requiresPartner: false,
    details: [
      'detail_newyear_1',
      'detail_newyear_2',
      'detail_newyear_3',
      'detail_newyear_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_7',
        rating: 4,
        comment: 'review_newyear_1'
      }
    ]
  },
  {
    id: 6,
    type: 'career',
    category: 'cat_career',
    titleKey: 'product_career_title',
    descriptionKey: 'product_career_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-6.png',
    requiresPartner: false,
    details: [
      'detail_career_1',
      'detail_career_2',
      'detail_career_3',
      'detail_career_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_8',
        rating: 5,
        comment: 'review_career_1'
      }
    ]
  },
  {
    id: 7,
    type: 'wealth',
    category: 'cat_wealth',
    titleKey: 'product_wealth_title',
    descriptionKey: 'product_wealth_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/saju-7.png',
    requiresPartner: false,
    details: [
      'detail_wealth_1',
      'detail_wealth_2',
      'detail_wealth_3',
      'detail_wealth_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_9',
        rating: 4,
        comment: 'review_wealth_1'
      }
    ]
  },
  {
    id: 8,
    type: 'tarot_love',
    category: 'cat_tarot_love',
    titleKey: 'product_tarot_love_title',
    descriptionKey: 'product_tarot_love_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/tarot-1.png',
    requiresPartner: false,
    details: [
      'detail_tarot_love_1',
      'detail_tarot_love_2',
      'detail_tarot_love_3',
      'detail_tarot_love_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_10',
        rating: 5,
        comment: 'review_tarot_love_1'
      }
    ]
  },
  {
    id: 9,
    type: 'tarot_future',
    category: 'cat_tarot_future',
    titleKey: 'product_tarot_future_title',
    descriptionKey: 'product_tarot_future_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/tarot-2.png',
    requiresPartner: false,
    details: [
      'detail_tarot_future_1',
      'detail_tarot_future_2',
      'detail_tarot_future_3',
      'detail_tarot_future_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_11',
        rating: 4,
        comment: 'review_tarot_future_1'
      }
    ]
  },
  {
    id: 10,
    type: 'tarot_career',
    category: 'cat_tarot_career',
    titleKey: 'product_tarot_career_title',
    descriptionKey: 'product_tarot_career_desc',
    originalPrice: 39000,
    discountRate: 49,
    finalPrice: 19900,
    image: '/images/tarot-3.png',
    requiresPartner: false,
    details: [
      'detail_tarot_career_1',
      'detail_tarot_career_2',
      'detail_tarot_career_3',
      'detail_tarot_career_4'
    ],
    reviews: [
      {
        id: 1,
        author: 'reviewer_12',
        rating: 5,
        comment: 'review_tarot_career_1'
      }
    ]
  }
];

// Helper function to get product by ID
export const getProductById = (id) => {
  return products.find(product => product.id === parseInt(id));
};

// Helper function to get products by category
export const getProductsByCategory = (category) => {
  return products.filter(product => product.category === category);
};

// Helper function to get best-selling products
export const getBestSellingProducts = (limit = 4) => {
  // In a real app, this would be based on actual sales data
  // For now, we'll just return the first few products
  return products.slice(0, limit);
};

export default products;
